import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { catchError, map, switchMap } from 'rxjs/operators';
import { FolderService, QueryService, WorkspaceService } from '@pt/api-client';
import { of } from 'rxjs';
import { FolderCreateResponse } from '@ms-organization-entities';
import * as FolderActions from '../actions/folder.actions';
import { WorkspaceItemType, WorkspaceMoveRequest } from '@primatoo-ms-organization';

@Injectable()
export class FolderEffects {
  renameFolder$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(FolderActions.renameFolder),
      switchMap((action) =>
        this.folderService.rename(action.id, action.request).pipe(
          map(() =>
            FolderActions.renameFolderSuccess({id: action.id})
          ),
          catchError(err =>
            of(FolderActions.renameFolderFailed({error: err.message}))
          )
        )
      )
    );
  });
  createFolder$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(FolderActions.createFolder),
      switchMap((action) => {
          return this.folderService.create(action.request).pipe(
            map((response: FolderCreateResponse) => FolderActions.createFolderSuccess({response})),
            catchError(err => of(FolderActions.createFolderFailed({error: err.message})))
          );
        }
      )
    );
  });
  moveFolder$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(FolderActions.moveFolder),
      switchMap((action: { id: number, workspaceMoveRequest: WorkspaceMoveRequest }) => {
          return this.workspaceService.move(action.id, WorkspaceItemType.FOLDER, action.workspaceMoveRequest).pipe(
            map((resource) =>
              FolderActions.moveFolderSuccess({item: resource})
            ),
            catchError(err => of(
              FolderActions.moveFolderFailed({error: err.message})
            ))
          );
        }
      )
    );
  });

  constructor(
    private actions$: Actions,
    private queryService: QueryService,
    private workspaceService: WorkspaceService,
    private folderService: FolderService) {
  }
}
